module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Wood#1-c9f5acc9c5ac5fd96dd874c857c0656f.svg";